import { useMantineTheme } from "@mantine/core";
import { useTranslation } from "@/i18n/client";
import { Loader } from "@/components/Loader";
import classes from "./index.module.css";
import { PropsWithChildren } from "react";
import Button from "@/components/Button";
import { useIsMutating } from "@tanstack/react-query";
import { ReactQueryKeys } from "@/constants/common";

interface ContinueButtonProps extends PropsWithChildren {
  isLoading?: boolean;
  onClick?: () => void | Promise<void>;
}

const ContinueButton = ({ isLoading = false, onClick, children }: ContinueButtonProps) => {
  const { t } = useTranslation("common");
  const theme = useMantineTheme();
  const contractMutations = useIsMutating({ mutationKey: ReactQueryKeys.mutateContract() });
  const handleClick = () => onClick?.();

  return (
    <Button
      className={`${classes.button} ${isLoading ? classes.loading : ""}`}
      fullWidth
      type="submit"
      onClick={onClick ? () => void handleClick() : undefined}
      disabled={isLoading || contractMutations > 0}>
      {children ?? t("continue")}
      {isLoading && <Loader customColor={theme.colors.red[0]} />}
    </Button>
  );
};

export default ContinueButton;
